import { useEffect, useState, useCallback } from "react";

const defaultAccessorFn = (item) => (item ? item.name || item.title || "" : "");

export const FilteredMenu = ({
  list,
  accessorFn = defaultAccessorFn,
  filter,
  children,
}) => {
  const [items, setItems] = useState([]);

  const memoizedAccessorFn = useCallback(accessorFn, []);

  useEffect(() => {
    if (!filter || filter.length === 0) {
      setItems(list);
      return;
    }

    const currentList = Array.isArray(list) ? list : [];

    const filteredItems = currentList.filter((item) => {
      return memoizedAccessorFn(item)
        .toLowerCase()
        .includes(filter?.toLowerCase() || "");
    });

    setItems(filteredItems);
  }, [filter, list, memoizedAccessorFn]);

  return children(items);
};
